/*
 * @Description: 员工管理
 * @Date: 2024-11-14 13:27:10
 */
import { route } from './src/router';

const name = 'employee-management';
export { name, route };
